// Gateway 型別查表（後端權威 gateway_*.proto，package Gateway）。
import type * as protobuf from 'protobufjs'
import { lookupType } from './protoRoot'

export function gatewayType(name: string): protobuf.Type {
  return lookupType(`Gateway.${name}`)
}
